import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "../Navbar.scss";

function DesktopMenu({ classes, navItems }) {

  return (
    <div className={classes?.navbar} data-testid="desktop-menu">
      <ul>
        {navItems?.map((item) => {
          return <Item item={item} keys={[item.id]} key={`item-${item?.id}`} />
        })}
      </ul>
    </div>
  );
}

function Item({ item, keys }) {
  return (
    <li>
      <a href={item?.url}>
        {item?.title}
        {item.itemList?.length !== 0 && <ArrowDropDownIcon />}
      </a>
      {item.itemList?.length !== 0 && (
        <ul>
          {item.itemList?.filter(Boolean).map((subitem) => {
            return <Item item={subitem} keys={[...keys, subitem.id]} key={`subitem-${keys.join('-')}-${subitem?.id}`}></Item>
          })}
        </ul>
      )}
    </li>
  )
}

export default DesktopMenu;
